import { IRawSchedule } from '../../models';
import { modifyIfEmpty } from './modify-if-empty';

export function getModifiedHoursIfEmpty(scheduleHours:Array<Array<IRawSchedule & string>>) {
  return scheduleHours.map((currentDayArray) => {
    return currentDayArray.map(modifyIfEmpty);
  });
}
